/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    
    export class UtilityService {

        public includeSpecifiedOptionsOnly(allOptions, includeList) {
            var restrictedList = [];
            for (var x = 0; x < allOptions.length; x++) {
                for (var y = 0; y < includeList.length; y++) {
                    if (allOptions[x].value === includeList[y]) {
                        restrictedList.push(allOptions[x]);
                        break;
                    }
                }
            }

            return restrictedList;
        }

        public removeSpecifiedOptions(allOptions, excludeList) {
            var restrictedList = [];
            var addToList = true;
            for (var x = 0; x < allOptions.length; x++) {
                for (var y = 0; y < excludeList.length; y++) {
                    if (allOptions[x].value == excludeList[y]) {
                        addToList = false;
                        break;
                    }
                }
                if (addToList) {
                    restrictedList.push(allOptions[x]);
                }
                addToList = true;
            }

            return restrictedList;
        }

        public safeConvertDate(field) {
            if (!field) return field;
            var dateWithoutTimeZoneOffset = new Date(field);
            var millisecondsSinceEpoc = dateWithoutTimeZoneOffset.getTime() + this.getTimeZoneOffsetInMilliseconds(dateWithoutTimeZoneOffset);
            return new Date(millisecondsSinceEpoc);
        }

        private getTimeZoneOffsetInMilliseconds(date: Date) {
            return date.getTimezoneOffset() * 60000;
        }

        public convertObjectToQueryString(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        }

        public static generateGuidComb(time?) {
            // Create a pseudo-Guid whose trailing 6 bytes (12 hex digits) are timebased
            // Start either with the given getTime() value, n, or get the current time in ms.
            // Each new Guid is greater than next if more than 1ms passes
            // See http://thatextramile.be/blog/2009/05/using-the-guidcomb-identifier-strategy
            // Based on breeze.core.getUuid which is based on this StackOverflow answer
            // http://stackoverflow.com/a/2117523/200253     
            // Convert time value to hex: n.toString(16)
            // Make sure it is 6 bytes long: ('00'+ ...).slice(-12) ... from the rear
            // Replace LAST 6 bytes (12 hex digits) of regular Guid (that's where they sort in a Db)
            // Play with this in jsFiddle: http://jsfiddle.net/wardbell/qS8aN/
            var timePart = ('00' + (time || (new Date().getTime())).toString(16)).slice(-12);
            return 'xxxxxxxx-xxxx-4xxx-yxxx-'.replace(/[xy]/g, function (c) {
                var resultArray = new Uint32Array(1);
                var randomValue = window.crypto.getRandomValues(resultArray)[0] / 4294967295 /* Max 32 bit number */;
                //var randomValue2 = Math.random();
                var r = randomValue * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            }) + timePart;
        }

        public static isNullOrWhiteSpace(str) {
            return (!str || str.length === 0 || /^\s*$/.test(str));
        }
    }
}

warsApp.registerService('UtilityService', []);